// LIBRARIES //
import React, { useState, useEffect } from 'react';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { Drawer } from '@yuhuinc/ui-library';

// COMPONENTS //
import NavTabFactory from './NavTabFactory';
import { InvitedDrawer, OptOutDrawer, PasswordResetDrawer, DeleteDrawer } from './DrawerStates';
import TenantOverviewHeader from '../TenantOverviewHeader';
import TabbedPanel from 'components/shared/TabbedPanel';
import MobileNavContainer from 'components/ui/MobileNavDropdown/MobileNavContainer';
import MobileNavCurrentTab from 'components/ui/MobileNavDropdown/MobileNavCurrentTab';

// HELPERS //
import { sizes } from 'helpers/MediaHelper';

// ACTIONS //
import * as actions from './store/actions';
import { getTenant } from 'actions/landlordTenantsActions';

export { actions };

const ResidentDrawer = ({
  onClose,
  reloadPageData,
  toggleChatDrawer,
  residentData,
  disabledProfilePicture,
  showResidentDrawer,
  closeResidentDrawer,
  showInvitedDrawer,
  showOptOutResident,
  showPasswordReset,
  showDeleteDrawer,
}) => {
  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const tenantId = params.get('tenantId');
    getTenant(tenantId, { all_maintenance_tickets: true });
  }, []);

  const closeDrawer = () => {
    onClose();
    closeResidentDrawer();
  };

  const [tabIndex, setTabIndex] = useState(0);

  const { tabHeaders, tabBodies, tabFooters, tabs } = NavTabFactory({
    residentData,
    disabledProfilePicture,
    closeDrawer,
    reloadPageData,
    toggleChatDrawer,
  });

  return (
    <React.Fragment>
      <Drawer visible={showResidentDrawer} onClose={closeDrawer}>
        <TenantOverviewHeader
          fullName={residentData.full_name}
          status={residentData.status}
          isPriorOrFutureTenant={residentData.is_prior_or_future_tenant}
          handleClickBack={closeDrawer}
          backgroundColor={'white'}
        />
        <MediaQuery query={`(min-device-width: ${sizes.desktop}px)`}>
          <TabbedPanel
            tabHeaders={tabHeaders}
            tabBodies={tabBodies}
            tabFooters={tabFooters}
            tabIndex={value => setTabIndex(value)}
            backgroundColor={'white'}
          />
        </MediaQuery>
        <MediaQuery query={`(max-device-width: ${sizes.mobile}px)`}>
          <MobileNavContainer
            tabIndex={tabIndex}
            tabs={tabs}
            onChange={value => setTabIndex(value)}
          />
          <MobileNavCurrentTab tabIndex={tabIndex} tabs={tabs} />
        </MediaQuery>
      </Drawer>
      <Drawer visible={showInvitedDrawer}>
        <InvitedDrawer firstName={residentData.first_name} />
      </Drawer>
      <Drawer visible={showOptOutResident}>
        <OptOutDrawer
          leadId={residentData.lead_id}
          residentId={residentData.id}
          optedOut={residentData.opted_out}
          reloadPageData={reloadPageData}
        />
      </Drawer>
      <Drawer visible={showPasswordReset}>
        <PasswordResetDrawer />
      </Drawer>
      <Drawer visible={showDeleteDrawer}>
        <DeleteDrawer
          residentId={residentData.id}
          leaseId={residentData.lease && residentData.lease.id}
          reloadPageData={reloadPageData}
          closeResidentDrawerCallback={closeDrawer}
        />
      </Drawer>
    </React.Fragment>
  );
};

export default connect(
  store => {
    return {
      residentData: store.landlordTenants.tenantDetails,
      disabledProfilePicture:
        store.companyDetails.companyPreferences.disable_residents_profile_picture,
      showResidentDrawer: store.landlord.residentDrawer.showResidentDrawer,
      showInvitedDrawer: store.landlord.residentDrawer.showInvitedDrawer,
      showOptOutResident: store.landlord.residentDrawer.showOptOutResident,
      showPasswordReset: store.landlord.residentDrawer.showPasswordReset,
      showDeleteDrawer: store.landlord.residentDrawer.showDeleteDrawer,
    };
  },
  { closeResidentDrawer: actions.closeResidentDrawer, getTenant }
)(ResidentDrawer);
